import { render } from "./showExchangeProcess.vue?vue&type=template&id=d8145b6e&scoped=true&lang=pug"
import script from "./showExchangeProcess.vue?vue&type=script&setup=true&lang=js"
export * from "./showExchangeProcess.vue?vue&type=script&setup=true&lang=js"

import "./showExchangeProcess.vue?vue&type=style&index=0&id=d8145b6e&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/cross-bridge v0.1.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8145b6e"]])

export default __exports__